import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";

import { Button } from "antd";
import classnames from "classnames";
import Canvas from "../canvas/Canvas";
import {
  ExpandOutlined
} from "@ant-design/icons";
import { useCanvasZoom } from "../../hooks/useCanvasZoom";
import { setSpinning } from "../../redux/designerPropertiesSlice";
import { useSeatsVisibility } from "../../hooks/useSeatsVisibility";
import { getSvgObject } from "../../utils/ObjectUtil";
import { Icons } from "../../enums";

const Preview = ({
  onChangePreview,
  objects,
}) => {
  const canvasRef = useRef();
  const dispatch = useDispatch();
  const previewClassName = classnames("container-preview", { preview: true });
  const { canZoomIn, canZoomOut } = useCanvasZoom(canvasRef);
  const [isMapLoaded, setIsMapLoaded] = useState(false);

  // Mostrar spinner en cuanto monta el componente,
  // ANTES de que el Canvas empiece a cargar
  useEffect(() => {
    dispatch(setSpinning(true));
  }, []);

  // Controlar ejecución de lógica de zoom máximo/mínimo solo una vez por ciclo
  // Mostrar labels, iconos y propagar listeners solo cuando no se puede hacer más zoom in
  useSeatsVisibility(canvasRef, canZoomIn, isMapLoaded, (seat) => {
    // Mostrar/ocultar iconos y labels
    const seatCircle = seat.item(0);
    seatCircle.set({ fill: `${seat.category.color}40`, stroke: seat.category.color });

    const seatIconOld = seat.item(2);
    if (seatIconOld) {
      seat.remove(seatIconOld);
    }

    // si el asiento es accesible, de compañia o tiene vista restringida, mostrar icono
    if (seat.accesible || seat.companion || seat.restrictedView) {
      if (seat.restrictedView)
        seat.insertAt(getSvgObject(Icons.restricted, (seatCircle.radius * 1.7), '#000000'), 2, true);
      else if (seat.accesible)
        seat.insertAt(getSvgObject(Icons.accesible, (seatCircle.radius * 1.7), '#000000'), 2, true);
      else if (seat.companion)
        seat.insertAt(getSvgObject(Icons.companion, (seatCircle.radius * 1.7), '#000000'), 2, true);
    } else {
      const seatText = seat.item(1);
      seatText.set({
        visible: true
      });
    }
  }, (seat) => {
    // Restaurar propiedades customizadas
    // Ocultar labels y restaurar iconos 
    const seatCircle = seat.item(0);
    seatCircle.set({ fill: `${seat.category.color}80`, stroke: "transparent" });

    const seatText = seat.item(1);
    seatText.set({ visible: false });

    const seatIcon = seat.item(2);
    if (seatIcon) {
      seat.remove(seatIcon);
    }
  });

  const handleZoomToFit = () => {
    canvasRef.current.handler.zoomHandler.zoomToFit();
  }

  return (
    <div
      className={previewClassName}
      style={{
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        width: "100vw",
        height: "100vh",
      }}
    >

      <div className="map-header-toolbar">
        <Button
          onClick={() => {
            canvasRef.current.handler.zoomHandler.zoomOut();
          }}
          disabled={!canZoomOut}
        >
          <span className="icon-zoom-out"></span>
        </Button>

        <Button
          onClick={handleZoomToFit}
        >
          <ExpandOutlined />
        </Button>
        <Button
          onClick={() => {
            canvasRef.current.handler.zoomHandler.zoomIn();
          }}
          disabled={!canZoomIn}
        >
          <span className="icon-icon-zoom-in"></span>
        </Button>
        <Button
          onClick={() => onChangePreview(false)}
          style={{ marginLeft: "auto" }}
        >
          <span className="icon-close"></span>
        </Button>
      </div>
      <Canvas
        ref={canvasRef}
        editable={false}
        selection={false}
        canvasOption={{ backgroundColor: "#FFFFFF" }}
        style={{ flex: 1, width: "100%", height: "100%" }}
        minZoom={10}
        maxZoom={1000}
        onLoad={async (handler) => {
          // El spinner ya está activo (disparado en useEffect).
          // Ahora cargamos el mapa de forma asíncrona.
          handler.interactionMode = "preview";
          handler.enablePanning = true;
          const rows = objects.filter(item => item.superType == "row");
          if (rows) {
            rows.forEach(row => {
              if (row.objects) {
                // Filtra solo los objetos que sean asientos
                const seatsInRow = row.objects.filter(obj => obj.superType === "seat");
                seatsInRow.forEach(seat => {
                  seat.objects = seat.objects.filter((item) => item.type !== "svg");
                  const seatCircle = seat.objects[0];
                  seatCircle.fill = `${seat.category.color}80`;
                  seatCircle.stroke = "transparent";

                  const seatText = seat.objects[1];
                  seatText.visible = false;
                });
              }
            });
          }
          await handler.importJSON(objects, "preview");
          setTimeout(() => {
            handler.zoomHandler.zoomToFit();
            dispatch(setSpinning(false));
            setIsMapLoaded(true);
          }, 150);
        }}
      />
    </div>
  );
};

export default Preview;

